(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9782],{

/***/ 1438:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ce": function() { return /* binding */ useIsDesktop; },
/* harmony export */   "Hi": function() { return /* binding */ Desktop; },
/* harmony export */   "Y9": function() { return /* binding */ LargeScreen; },
/* harmony export */   "_": function() { return /* binding */ MediumScreen; },
/* harmony export */   "ij": function() { return /* binding */ Mobile; }
/* harmony export */ });
/* unused harmony exports useCustomQuery, IEMediaQuery, EdgeMediaQuery */
/* harmony import */ var _material_ui_core_Hidden__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53450);
/* harmony import */ var _material_ui_core_useMediaQuery__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63457);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



var useCustomQuery = function useCustomQuery(minWidth) {
  return _useMediaQuery("(min-width:".concat(minWidth, "px)"));
};
var useIsDesktop = function useIsDesktop() {
  return (0,_material_ui_core_useMediaQuery__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function (theme) {
    return theme.breakpoints.up("md");
  });
};
var Mobile = function Mobile(_ref) {
  var children = _ref.children,
      _ref$aboveTheFold = _ref.aboveTheFold,
      aboveTheFold = _ref$aboveTheFold === void 0 ? false : _ref$aboveTheFold;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Hidden__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    implementation: aboveTheFold ? "css" : "js",
    mdUp: true,
    children: children
  });
};
var Desktop = function Desktop(_ref2) {
  var children = _ref2.children,
      _ref2$aboveTheFold = _ref2.aboveTheFold,
      aboveTheFold = _ref2$aboveTheFold === void 0 ? false : _ref2$aboveTheFold;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Hidden__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    implementation: aboveTheFold ? "css" : "js",
    smDown: true,
    children: children
  });
};
var MediumScreen = function MediumScreen(_ref3) {
  var children = _ref3.children,
      _ref3$aboveTheFold = _ref3.aboveTheFold,
      aboveTheFold = _ref3$aboveTheFold === void 0 ? false : _ref3$aboveTheFold;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Hidden__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    implementation: aboveTheFold ? "css" : "js",
    only: ["xs", "sm", "xl"],
    children: children
  });
};
var LargeScreen = function LargeScreen(_ref4) {
  var children = _ref4.children,
      _ref4$aboveTheFold = _ref4.aboveTheFold,
      aboveTheFold = _ref4$aboveTheFold === void 0 ? false : _ref4$aboveTheFold;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Hidden__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    implementation: aboveTheFold ? "css" : "js",
    lgDown: true,
    children: children
  });
};
var IEMediaQuery = "@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)";
var EdgeMediaQuery = "@supports (-ms-ime-align:auto)";

/***/ }),

/***/ 31353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports seoKeys, emptySeo */
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2962);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




var seoKeys = {// NotFound: "notFound",
  // Homepage: "homePage",
  // firstHand: `firstHand_`, // use with car id. example: {firstHand_122123}
  // zeroKm: "zeroKm_", // use with car slug. example: {zeroKm_14/629/271/2021}
  // leasing: "leasing_", // use with car slug. example: {leasing_14/629/271/2021}
};

for (var key in seoKeys) {
  seoKeys[key] = encodeURIComponent(seoKeys[key].replace(/\/\[.+/, "").replace("/", "").replace(/-/g, " "));
}

var emptySeo = {
  title: " ",
  description: "",
  keywords: ""
};

var SeoMetaData = function SeoMetaData(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: data && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_0__/* .NextSeo */ .PB, {
      title: data.title,
      description: data.description || "",
      additionalMetaTags: [{
        name: "title",
        content: data.title
      }, {
        name: "keywords",
        content: data.keywords
      }, {
        name: "description",
        content: data.description
      }],
      openGraph: {
        title: data.title,
        description: data.description || ""
      }
    })
  });
};

/* harmony default export */ __webpack_exports__["ZP"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(SeoMetaData));

/***/ }),

/***/ 9108:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ GenericInput; },
/* harmony export */   "p": function() { return /* binding */ errorAndFocusStyles; }
/* harmony export */ });
/* harmony import */ var components_QuickPurchasePage_Form_FormInput__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73033);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50066);


var errorAndFocusStyles = "\n// Focus and Error Handling\n\n  .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {\n    box-shadow: none !important;\n  }\n\n  .MuiOutlinedInput-root {\n    border-radius: 8px;\n    box-shadow: none;\n\n\n    fieldset {\n      border: 1px solid #e5e5e5; // Gray border when there's no focus or error\n      outline: none;\n    }\n\n    &.Mui-error {\n      fieldset {\n        border: 1px solid #db0007; // Red border for error\n      }\n\n      input {\n        font-size: 20px;\n      }\n    }\n\n    &:focus-within {\n      fieldset {\n        border: 1px solid #f7c600; // Yellow border on focus even with error\n        color: var(--Black, var(--Primary-Black, #000));\n      }\n    }\n\n    &.Mui-error:focus-within {\n      fieldset {\n        border: 1px solid #f7c600; // Ensure yellow border on focus with error\n        color: var(--Black, var(--Primary-Black, #000));\n      }\n    }\n  }\n\n  .MuiFormHelperText-root.Mui-error {\n    font-size: 14px;\n    margin-top:0;\n  }\n";
var GenericInput = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(components_QuickPurchasePage_Form_FormInput__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z).withConfig({
  displayName: "GenericInput",
  componentId: "sc-52hros-0"
})(["input[type=\"email\"]{font-size:20px;font-family:Speedee,NarkisBlock;direction:ltr;text-align:right;}.MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-formControl{width:", "px;height:", "px;", "}", "{.MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-formControl{width:", ";}}.MuiOutlinedInput-multiline{padding:23px 0px 18.5px 0;textarea{padding:0 8px;}}.MuiFormHelperText-root.MuiFormHelperText-contained{min-height:15px;}.Mui-focused{border:0;outline:0;box-shadow:0;}.MuiFormControl-root{", "}.MuiButtonBase-root.MuiIconButton-root{padding:12px 0 12px 12px;}.MuiOutlinedInput-adornedStart{padding-right:8px;}.MuiOutlinedInput-input{padding:16px 8px 0px 8px;", " font-family:Speedee,NarkisBlock;font-size:20px;font-style:normal;font-weight:400;line-height:normal;&:not(:focus){color:var(--Grey,#6f6f6f);}&:not(:focus){color:#000;}&.Mui-error:not(:focus){color:#000;}}.MuiInputLabel-root{font-size:18px;font-family:NarkisBlock;}.MuiInputLabel-outlined{transform:translate(-8px,16px);", "{transform:translate(-8px,18px);}}.MuiInputLabel-outlined.MuiInputLabel-shrink{transform:translate(-8px,8px) scale(1);", " color:var(--Grey,#757575);font-family:Speedee,NarkisBlock;font-size:14px;font-style:normal;font-weight:400;line-height:normal;letter-spacing:0.21px;}", " ", ""], function (p) {
  return (p === null || p === void 0 ? void 0 : p.$width) || "312";
}, function (p) {
  return p !== null && p !== void 0 && p.$height ? p === null || p === void 0 ? void 0 : p.$height : "56";
}, function (p) {
  return p.multiline ? (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["height:auto;min-height:", "px;"], p !== null && p !== void 0 && p.$height ? p === null || p === void 0 ? void 0 : p.$height : "56") : "";
}, function (p) {
  return p.theme.breakpoints.down("sm");
}, function (p) {
  return (p === null || p === void 0 ? void 0 : p.$mobileWidth) || "100%";
}, function (p) {
  return (p === null || p === void 0 ? void 0 : p.$mobileWidth) && "width: ".concat(p.$mobileWidth, ";");
}, function (p) {
  return (p === null || p === void 0 ? void 0 : p.$hasIcon) && "padding: 16px 0 0px 8px;";
}, function (p) {
  return p.theme.breakpoints.down("sm");
}, function (p) {
  return (p === null || p === void 0 ? void 0 : p.$hasIcon) && "transform: translate(-44px, 8px) scale(1);";
}, function (p) {
  return (p === null || p === void 0 ? void 0 : p.$unicodeBidi) && "\n      input {\n        unicode-bidi: ".concat(function (p) {
    return p.$unicodeBidi;
  }, ";\n        text-align: right;\n\n      }\n    ");
}, errorAndFocusStyles);

/***/ }),

/***/ 2936:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



var SvgComponent = function SvgComponent() {
  var w = 31;
  var h = 31;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "back arrow",
    width: w,
    height: h,
    viewBox: "0 0 31 31",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
      "data-name": "Ellipse 6",
      cx: "15.5",
      cy: "15.5",
      r: "15.5",
      fill: "#f7f7f7"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
      "data-name": "Path 603",
      d: "M13.843 20.428a.5.5 0 0 1-.319-.881L18.38 15.5l-4.857-4.046a.5.5 0 1 1 .638-.766l5.316 4.43a.5.5 0 0 1 0 .765l-5.316 4.43a.5.5 0 0 1-.318.115z"
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgComponent);

/***/ }),

/***/ 73033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(16835);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4730);
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22318);
/* harmony import */ var _material_ui_core_InputLabel__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85161);
/* harmony import */ var _material_ui_core_FormControl__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64436);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82175);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50066);
/* harmony import */ var _Reusable_Bit_Form_FormikInput__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60137);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);






var _excluded = ["name", "label", "type", "required", "placeholder", "maxLength", "numeric", "InputProps", "centerField", "autoFocus", "topMargin", "autoComplete", "mobileTopMargin"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var Styled = {
  Field: (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(formik__WEBPACK_IMPORTED_MODULE_1__.Field).withConfig({
    displayName: "FormInput__Field",
    componentId: "sc-ju03wp-0"
  })(["width:100%;.MuiFormHelperText-root{font-size:20px;}.MuiFormHelperText-root.Mui-error{", ";}input{", "}"], function (p) {
    return p.$center ? "text-align: center;" : "";
  }, function (p) {
    return p.$center ? "text-align: center;" : "";
  }),
  FormControl: (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_material_ui_core_FormControl__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    displayName: "FormInput__FormControl",
    componentId: "sc-ju03wp-1"
  })([""]),
  FieldWrapper: styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "FormInput__FieldWrapper",
    componentId: "sc-ju03wp-2"
  })(["margin-top:", ";input{font-family:Speedee,NarkisBlock,sans-serif;color:#000;font-size:20px;font-weight:500;}input[type=\"email\"]{font-size:16px;font-family:sans-serif,Speedee;font-weight:normal;}input::-webkit-outer-spin-button,input::-webkit-inner-spin-button{-webkit-appearance:none;}.MuiOutlinedInput-root.Mui-error{fieldset{box-shadow:none;border:1px solid #db0007;top:0px;border-radius:8px;height:56px;}}.MuiOutlinedInput-root{border-radius:8px;box-shadow:none;}.MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-formControl{border-radius:8px;background:#fff;}.MuiFormLabel-root.Mui-error{color:#000;font-family:NarkisBlock;}", "{", " fieldset{min-height:50px;}}"], function (p) {
    return p.$topMargin ? "".concat(p.$topMargin, "px") : "28px";
  }, function (p) {
    return p.theme.breakpoints.down("sm");
  }, function (p) {
    return (p === null || p === void 0 ? void 0 : p.$mobileTopMargin) && "margin-top: ".concat(p.$mobileTopMargin, "px;");
  }),
  LabelWrapper: styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "FormInput__LabelWrapper",
    componentId: "sc-ju03wp-3"
  })(["display:flex;align-items:center;"]),
  InputLabel: (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_material_ui_core_InputLabel__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    displayName: "FormInput__InputLabel",
    componentId: "sc-ju03wp-4"
  })(["transform:none !important;font-size:18px;color:", ";font-weight:400;", ";line-height:1.44;margin-top:5px;"], function (p) {
    return p.theme.colors.darkGrey;
  }, function (p) {
    return p.$center ? "width: 100%; right: none; text-align: center;" : "";
  }),
  BottomText: (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z).attrs({
    variant: "body1"
  }).withConfig({
    displayName: "FormInput__BottomText",
    componentId: "sc-ju03wp-5"
  })(["text-align:start;font-size:15px;margin-top:-23px;color:", ";"], function (p) {
    return p.theme.colors.marbleGrey;
  })
};

var FormInput = function FormInput(_ref) {
  var name = _ref.name,
      label = _ref.label,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "text" : _ref$type,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      placeholder = _ref.placeholder,
      maxLength = _ref.maxLength,
      numeric = _ref.numeric,
      InputProps = _ref.InputProps,
      centerField = _ref.centerField,
      autoFocus = _ref.autoFocus,
      topMargin = _ref.topMargin,
      autoComplete = _ref.autoComplete,
      mobileTopMargin = _ref.mobileTopMargin,
      props = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_ref, _excluded);

  var _useField = (0,formik__WEBPACK_IMPORTED_MODULE_1__.useField)(name),
      _useField2 = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_useField, 1),
      field = _useField2[0];

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_material_ui_core_FormControl__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Styled.FieldWrapper, {
      $topMargin: topMargin,
      $mobileTopMargin: mobileTopMargin,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_Reusable_Bit_Form_FormikInput__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread(_objectSpread({
        name: name,
        type: type,
        required: required,
        placeholder: placeholder,
        maxLength: maxLength,
        numeric: numeric,
        centerField: centerField,
        InputProps: InputProps,
        autoFocus: autoFocus,
        label: label,
        autoComplete: autoComplete
      }, field), props))
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (FormInput);

/***/ }),

/***/ 34968:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50029);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var focus_formik_error__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73192);
/* harmony import */ var focus_formik_error__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(focus_formik_error__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82175);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);








function FormikForm(_ref) {
  var validationSchema = _ref.validationSchema,
      initialValues = _ref.initialValues,
      render = _ref.render,
      onSubmit = _ref.onSubmit,
      validate = _ref.validate,
      innerRef = _ref.innerRef,
      alwaysValidate = _ref.alwaysValidate;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false),
      formIsDirty = _useState[0],
      setFormIsDirty = _useState[1];

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(formik__WEBPACK_IMPORTED_MODULE_2__.Formik, {
    validate: validate,
    innerRef: innerRef,
    initialValues: initialValues,
    validationSchema: validationSchema,
    validateOnMount: false,
    validateOnChange: alwaysValidate || formIsDirty,
    validateOnBlur: alwaysValidate || formIsDirty,
    onSubmit: /*#__PURE__*/function () {
      var _ref2 = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(values, actions) {
        return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                actions.setSubmitting(true);
                _context.next = 3;
                return onSubmit(values, actions);

              case 3:
                actions.setSubmitting(false);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref2.apply(this, arguments);
      };
    }(),
    enableReinitialize: true,
    children: function children(formik) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(formik__WEBPACK_IMPORTED_MODULE_2__.Form, {
        noValidate: true,
        onSubmit: function onSubmit(e) {
          e.preventDefault();
          setFormIsDirty(true); // changes formkit.validateOnChange state to true

          return formik.handleSubmit();
        },
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(focus_formik_error__WEBPACK_IMPORTED_MODULE_1__.ConnectedFocusError, {}), render(formik)]
      });
    }
  });
}

/* harmony default export */ __webpack_exports__["Z"] = (FormikForm);

/***/ }),

/***/ 60137:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4730);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82175);
/* harmony import */ var formik_material_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74938);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50066);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


var _excluded = ["name", "label", "type", "required", "placeholder", "maxLength", "numeric", "InputProps", "centerField", "autoFocus"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var Styled = {
  Field: (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(formik__WEBPACK_IMPORTED_MODULE_1__.Field).withConfig({
    displayName: "FormikInput__Field",
    componentId: "sc-1jyipnl-0"
  })(["width:100%;.MuiFormHelperText-root{font-size:18px;font-family:Speedee,NarkisBlock-Thin,sans-serif;}.MuiFormHelperText-root.Mui-error{", ";color:#d70202;}input{", "}"], function (p) {
    return p.$center ? "text-align: center;" : "";
  }, function (p) {
    return p.$center ? "text-align: center;" : "";
  })
};

// todo the error messageis not working!
var FormikInput = function FormikInput(_ref) {
  var name = _ref.name,
      label = _ref.label,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "text" : _ref$type,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      placeholder = _ref.placeholder,
      maxLength = _ref.maxLength,
      numeric = _ref.numeric,
      InputProps = _ref.InputProps,
      centerField = _ref.centerField,
      autoFocus = _ref.autoFocus,
      props = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Styled.Field, _objectSpread({
    $center: centerField,
    label: label,
    component: formik_material_ui__WEBPACK_IMPORTED_MODULE_2__/* .TextField */ .nv,
    id: name,
    name: name,
    type: type,
    required: required,
    helperText: " ",
    placeholder: placeholder,
    inputProps: {
      maxLength: maxLength,
      inputMode: numeric && "numeric",
      pattern: numeric && "[0-9]*",
      style: {
        direction: type === "tel" ? "rtl" : undefined
      }
    },
    InputProps: _objectSpread({}, InputProps),
    autoFocus: autoFocus,
    variant: "outlined"
  }, props));
};

/* harmony default export */ __webpack_exports__["Z"] = (FormikInput);

/***/ }),

/***/ 39163:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C1": function() { return /* binding */ required; },
/* harmony export */   "Cr": function() { return /* binding */ schemaCommon; },
/* harmony export */   "I1": function() { return /* binding */ invalid; },
/* harmony export */   "Sz": function() { return /* binding */ regex; }
/* harmony export */ });
/* unused harmony export max */
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74231);

var max = {
  fullname: [50, "ניתן להזין עד 50 תווים"]
};
var required = {
  "default": "שדה זה הינו שדה חובה",
  firstName: "יש להזין שם פרטי",
  lastName: "יש להזין שם משפחה",
  phoneNumber: "יש להזין מספר טלפון",
  licenseNumber: "יש להזין לוחית רישוי",
  licenceOrChassis: "נא הכנס מספר רישוי או שילדה",
  modelId: "בחר דגם",
  area: "בחר איזור",
  skuOrName: "נא הכנס טקסט חופשי או מספר פריט"
};
var regex = {
  numbers: /^[0-9]*$/,
  singleName: /^[a-zA-Zא-ת׳״ء-ي'"‘’\\.\-,\s]+$/,
  fullName: /([a-zA-Zא-תء-ي'"\\.-/,].+\s).+/,
  name: /^[A-Za-zء-ي ,.'-]+$/,
  phoneNumber: /^05(\d+-?)+\d+$/,
  phoneNumberCompany: /^(?:\+972-?|0)(?:5\d|[2-9]|7\d)(?:-)?\d{7}$/,
  licenseNumber: /^([0-9]{2}-[0-9]{3}-[0-9]{2}|[0-9]{3}-[0-9]{2}-[0-9]{3}|[0-9]{7,8})$/,
  licenceOrChassis: /^(([0-9]{2}-[0-9]{3}-[0-9]{2}|[0-9]{3}-[0-9]{2}-[0-9]{3}|[0-9]{7,8})|([A-Z]{2}[A-Z0-9]{12}))$/,
  companyId: /^51\d{7}$/,
  amount: /^₪?\d*$/
};
var invalid = {
  numbers: "יש להזין ספרות בלבד",
  fullName: "שם מלא לא תקין",
  name: "יש להזין אותיות בעברית / אנגלית בלבד",
  email: "כתובת המייל אינה תקינה",
  phoneNumber: "מספר הטלפון אינו תקין",
  licenseNumber: "נא להזין מספר בעל 7-8 תווים המורכב מספרות בלבד",
  licenceOrChassis: "מספר רישוי או שילדה לא תקין",
  amount: "ניתן להכניס ספרות בלבד",
  companyId: "יש להזין מס' ח.פ. תקין",
  groupPurchaseAmount: "הסכום שהזנת גדול מהסכום שניתן לרכוש"
};
var schemaCommon = {
  phoneNumberCompany: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().matches(regex.phoneNumberCompany, "יש להזין מספר טלפון תקין").required(required["default"]).max(11, "יש להזין עד 10 ספרות בלבד"),
  phoneNumber: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().matches(regex.phoneNumber, "יש להזין מספר טלפון תקין").required(required["default"]).min(10, "יש להזין לפחות 10 ספרות").max(12, "יש להזין עד 10 ספרות בלבד"),
  firstName: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().trim().matches(regex.singleName, "ניתן להזין אותיות בלבד, כולל מקף או גרש").min(2, "יש להזין לפחות שתי אותיות").required(required["default"]).max(30, "ניתן להזין עד 30 תווים").test("not-only-spaces", "יש להזין שם שאינו ריק", function (value) {
    return !!value && value.trim().length > 0;
  }),
  lastName: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().trim().matches(regex.singleName, "ניתן להזין אותיות בלבד, כולל מקף או גרש").min(2, "יש להזין לפחות שתי אותיות").required(required["default"]).max(30, "ניתן להזין עד 30 תווים").test("not-only-spaces", "יש להזין שם שאינו ריק", function (value) {
    return !!value && value.trim().length > 0;
  }),
  fullName: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().trim().matches(regex.singleName, "ניתן להזין אותיות בלבד, כולל מקף או גרש").min(2, "יש להזין לפחות שתי אותיות").required(required["default"]).max(30, "ניתן להזין עד 30 תווים").test("not-only-spaces", "יש להזין שם שאינו ריק", function (value) {
    return !!value && value.trim().length > 0;
  }),
  email: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().email("יש להזין כתובת מייל תקינה").required(required["default"]),
  recipientEmail: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().email("יש להזין כתובת מייל תקינה"),
  city: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_(),
  street: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_(),
  apartmentNumber: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().matches(regex.numbers, invalid.numbers),
  floorNumber: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().matches(regex.numbers, invalid.numbers),
  entranceNumber: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().matches(regex.numbers, invalid.numbers),
  comments: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_(),
  checkbox: yup__WEBPACK_IMPORTED_MODULE_0__/* .bool */ .Xg().oneOf([true], "יש לאשר את תנאי השימוש"),
  qauntity: yup__WEBPACK_IMPORTED_MODULE_0__/* .number */ .Rx().min(1, "יש לבחור כמות גיפטקארדים לרכישה"),
  amount: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().matches(regex.amount, invalid.amount).required(required["default"]),
  companyId: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().matches(regex.companyId, invalid.companyId).required(required["default"]),
  groupName: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().min(2, "יש להזין מינימום 2 תווים").required("יש להזין מינימום 2 תווים").max(50, "ניתן להזין עד 50 תווים"),
  senderBlessing: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().max(200, "ניתן להזין עד 200 תווים")
};

/***/ }),

/***/ 71947:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CompaniesSteps": function() { return /* binding */ CompaniesSteps; },
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ companies; }
});

// EXTERNAL MODULE: ./common/SeoMetaData.tsx
var SeoMetaData = __webpack_require__(31353);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/IconButton/IconButton.js
var IconButton = __webpack_require__(17812);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js + 14 modules
var Box = __webpack_require__(50253);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Container/Container.js
var Container = __webpack_require__(43832);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./api/index.ts + 2 modules
var api = __webpack_require__(91315);
// EXTERNAL MODULE: ./common/MediaQueries.tsx
var MediaQueries = __webpack_require__(1438);
// EXTERNAL MODULE: ./components/GenericButton/GenericButton.tsx
var GenericButton = __webpack_require__(92208);
// EXTERNAL MODULE: ./components/GenericInput/GenericInput.tsx
var GenericInput = __webpack_require__(9108);
// EXTERNAL MODULE: ./components/PurchasePage/CompaniesContext.tsx
var CompaniesContext = __webpack_require__(7520);
// EXTERNAL MODULE: ./components/Reusable/Bit/Form/FormikForm.tsx
var FormikForm = __webpack_require__(34968);
// EXTERNAL MODULE: ./components/Reusable/Functions/Functions.ts
var Functions = __webpack_require__(64416);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-google-recaptcha/lib/esm/index.js + 3 modules
var esm = __webpack_require__(34853);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50066);
// EXTERNAL MODULE: ./components/Icons/BackIcon.tsx
var BackIcon = __webpack_require__(2936);
// EXTERNAL MODULE: ./components/Reusable/Bit/FormikSchema.ts
var FormikSchema = __webpack_require__(39163);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
;// CONCATENATED MODULE: ./components/Companies/CompaniesForm.tsx


var companiesInitialValues = {
  firstName: "",
  lastName: "",
  companyName: "",
  companyIdNumber: "",
  phoneNumber: "",
  email: "",
  notes: "",
  gRecaptchaResponse: true
};
var schemaCompanies = es/* object */.Ry({
  firstName: FormikSchema/* schemaCommon.firstName */.Cr.firstName,
  lastName: FormikSchema/* schemaCommon.lastName */.Cr.lastName,
  companyName: FormikSchema/* schemaCommon.firstName */.Cr.firstName,
  companyIdNumber: FormikSchema/* schemaCommon.companyId */.Cr.companyId,
  phoneNumber: FormikSchema/* schemaCommon.phoneNumberCompany */.Cr.phoneNumberCompany,
  email: FormikSchema/* schemaCommon.email */.Cr.email
}).defined();
/* harmony default export */ var CompaniesForm = ({
  companiesInitialValues: companiesInitialValues,
  schemaCompanies: schemaCompanies
});
// EXTERNAL MODULE: ./components/Reusable/Bit/NextLink.tsx
var NextLink = __webpack_require__(16110);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/Icons/CompaniesPhoneIcon.tsx


var SvgComponent = function SvgComponent() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M13.75 1.25H6.25C5.75272 1.25 5.27581 1.44754 4.92417 1.79917C4.57254 2.15081 4.375 2.62772 4.375 3.125V16.875C4.375 17.3723 4.57254 17.8492 4.92417 18.2008C5.27581 18.5525 5.75272 18.75 6.25 18.75H13.75C14.2473 18.75 14.7242 18.5525 15.0758 18.2008C15.4275 17.8492 15.625 17.3723 15.625 16.875V3.125C15.625 2.62772 15.4275 2.15081 15.0758 1.79917C14.7242 1.44754 14.2473 1.25 13.75 1.25ZM14.375 16.875C14.375 17.0408 14.3092 17.1997 14.1919 17.3169C14.0747 17.4342 13.9158 17.5 13.75 17.5H6.25C6.08424 17.5 5.92527 17.4342 5.80806 17.3169C5.69085 17.1997 5.625 17.0408 5.625 16.875V3.125C5.625 2.95924 5.69085 2.80027 5.80806 2.68306C5.92527 2.56585 6.08424 2.5 6.25 2.5H13.75C13.9158 2.5 14.0747 2.56585 14.1919 2.68306C14.3092 2.80027 14.375 2.95924 14.375 3.125V16.875ZM10.9375 4.6875C10.9375 4.87292 10.8825 5.05418 10.7795 5.20835C10.6765 5.36252 10.5301 5.48268 10.3588 5.55364C10.1875 5.62459 9.99896 5.64316 9.8171 5.60699C9.63525 5.57081 9.4682 5.48152 9.33709 5.35041C9.20598 5.2193 9.11669 5.05225 9.08051 4.8704C9.04434 4.68854 9.06291 4.50004 9.13386 4.32873C9.20482 4.15743 9.32498 4.01101 9.47915 3.908C9.63332 3.80498 9.81458 3.75 10 3.75C10.2486 3.75 10.4871 3.84877 10.6629 4.02459C10.8387 4.2004 10.9375 4.43886 10.9375 4.6875Z",
      fill: "black"
    })
  });
};

/* harmony default export */ var CompaniesPhoneIcon = (SvgComponent);
;// CONCATENATED MODULE: ./components/Icons/CompaniesWhatsappIcon.tsx


var CompaniesWhatsappIcon_SvgComponent = function SvgComponent() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M14.7771 11.3494L12.2128 10.0673C12.1118 10.017 11.9994 9.99425 11.8868 10.0013C11.7743 10.0083 11.6656 10.0449 11.5717 10.1074L10.3945 10.8926C9.85409 10.5956 9.40938 10.1509 9.11231 9.6106L9.89764 8.43351C9.96012 8.33963 9.99672 8.23093 10.0038 8.11838C10.0108 8.00583 9.98801 7.89342 9.93771 7.79249L8.65553 5.22839C8.60239 5.12107 8.52024 5.03079 8.41841 4.96776C8.31657 4.90474 8.19912 4.8715 8.07936 4.87182C7.22922 4.87182 6.41391 5.2095 5.81277 5.81058C5.21164 6.41165 4.87392 7.22689 4.87392 8.07694C4.87604 9.94641 5.61969 11.7387 6.94173 13.0606C8.26377 14.3825 10.0562 15.1261 11.9259 15.1282C12.3468 15.1282 12.7636 15.0453 13.1525 14.8842C13.5414 14.7232 13.8948 14.4871 14.1925 14.1895C14.4901 13.8918 14.7262 13.5385 14.8873 13.1496C15.0484 12.7608 15.1313 12.344 15.1313 11.9231C15.1314 11.804 15.0983 11.6872 15.0357 11.5859C14.9732 11.4846 14.8836 11.4027 14.7771 11.3494ZM11.9259 13.8462C10.3962 13.8445 8.92958 13.2361 7.8479 12.1545C6.76622 11.073 6.15779 9.60652 6.1561 8.07694C6.15597 7.63233 6.30993 7.2014 6.59176 6.85751C6.8736 6.51361 7.2659 6.27798 7.70192 6.19073L8.62188 8.03367L7.83895 9.19874C7.78044 9.28649 7.74449 9.38732 7.73429 9.49229C7.72409 9.59726 7.73994 9.70312 7.78045 9.8005C8.23913 10.8906 9.10639 11.7577 10.1965 12.2164C10.2942 12.2587 10.4009 12.276 10.507 12.2668C10.613 12.2575 10.7151 12.222 10.804 12.1635L11.9748 11.383L13.8179 12.3029C13.7299 12.7394 13.4933 13.1318 13.1482 13.4133C12.8032 13.6947 12.3712 13.8477 11.9259 13.8462ZM10.0026 1.66669C8.56375 1.66637 7.14931 2.03855 5.89698 2.747C4.64464 3.45544 3.59707 4.47602 2.85624 5.70939C2.1154 6.94277 1.70653 8.34691 1.66944 9.78516C1.63234 11.2234 1.96827 12.6468 2.64454 13.9167L1.735 16.6451C1.65966 16.8709 1.64872 17.1134 1.70342 17.3451C1.75812 17.5769 1.87629 17.7888 2.04468 17.9572C2.21308 18.1256 2.42504 18.2437 2.65682 18.2984C2.8886 18.3531 3.13103 18.3422 3.35695 18.2668L6.08558 17.3574C7.20329 17.9518 8.44174 18.2838 9.70694 18.3282C10.9721 18.3726 12.2308 18.1282 13.3875 17.6136C14.5441 17.099 15.5683 16.3276 16.3822 15.3581C17.1962 14.3886 17.7786 13.2464 18.0852 12.0182C18.3918 10.7901 18.4146 9.50819 18.1517 8.26992C17.8889 7.03165 17.3474 5.86952 16.5683 4.87175C15.7893 3.87398 14.7931 3.06678 13.6555 2.51144C12.5178 1.9561 11.2686 1.66721 10.0026 1.66669ZM10.0026 17.0513C8.7629 17.0521 7.54493 16.7257 6.47183 16.105C6.39326 16.0594 6.30591 16.0311 6.21556 16.0218C6.1252 16.0126 6.03392 16.0226 5.94774 16.0513L2.95066 17.0513L3.94995 14.0545C3.97876 13.9684 3.98894 13.8771 3.97982 13.7868C3.9707 13.6965 3.9425 13.6091 3.89706 13.5305C3.11972 12.1866 2.80762 10.6239 3.00918 9.0846C3.21074 7.54532 3.91469 6.11558 5.01182 5.01716C6.10896 3.91874 7.53795 3.21306 9.07712 3.00957C10.6163 2.80609 12.1796 3.11619 13.5245 3.89175C14.8695 4.66732 15.9208 5.86501 16.5155 7.29902C17.1103 8.73303 17.2151 10.3232 16.8137 11.8228C16.4124 13.3225 15.5273 14.6478 14.2958 15.5931C13.0643 16.5385 11.5552 17.051 10.0026 17.0513Z",
      fill: "black"
    })
  });
};

/* harmony default export */ var CompaniesWhatsappIcon = (CompaniesWhatsappIcon_SvgComponent);
;// CONCATENATED MODULE: ./components/Companies/SocialSection.tsx









var StyledBottomWrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "SocialSection__StyledBottomWrapper",
  componentId: "sc-d9agp0-0"
})(["display:flex;flex-direction:row;padding-bottom:30px;", "{margin-top:20px;padding-bottom:0px;}a{margin-left:20px;:hover{text-decoration:underline;}}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledIconWrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "SocialSection__StyledIconWrapper",
  componentId: "sc-d9agp0-1"
})(["p{font-weight:bold;margin-bottom:0px;margin-right:7px;}display:flex;align-items:center;"]);
var StyledSubtitle = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  variant: "body1"
}).withConfig({
  displayName: "SocialSection__StyledSubtitle",
  componentId: "sc-d9agp0-2"
})(["text-align:right;margin-bottom:37px;"]);
var StyledBottomText = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  variant: "h2"
}).withConfig({
  displayName: "SocialSection__StyledBottomText",
  componentId: "sc-d9agp0-3"
})(["text-align:right;margin-top:60px;margin-bottom:20px;font-size:26px;", "{margin-top:27px;margin-bottom:0px;}"], function (p) {
  return p.theme.breakpoints.up("md");
});

var SocialSection = function SocialSection(_ref) {
  var phone = _ref.phone,
      whatsapp = _ref.whatsapp;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledBottomText, {
      children: "\u05E8\u05D5\u05E6\u05D4 \u05DC\u05D3\u05D1\u05E8 \u05D0\u05D9\u05EA\u05E0\u05D5 \u05DB\u05D1\u05E8 \u05E2\u05DB\u05E9\u05D9\u05D5?"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledBottomWrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NextLink/* default */.Z, {
        href: "tel:".concat(phone),
        "aria-label": "\u05D3\u05D1\u05E8\u05D5 \u05D0\u05D9\u05EA\u05E0\u05D5 \u05DB\u05D1\u05E8 \u05E2\u05DB\u05E9\u05D9\u05D5 \u05D1\u05D8\u05DC\u05E4\u05D5\u05DF",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledIconWrapper, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CompaniesPhoneIcon, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledSubtitle, {
            children: phone
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(NextLink/* default */.Z, {
        href: whatsapp,
        openInNewTab: true,
        ariaLabel: " \u05D3\u05D1\u05E8\u05D5 \u05D0\u05D9\u05EA\u05E0\u05D5 \u05DB\u05D1\u05E8 \u05E2\u05DB\u05E9\u05D9\u05D5 \u05D1\u05D0\u05DE\u05E6\u05E2\u05D5\u05EA \u05D4\u05D5\u05D5\u05D0\u05D8\u05E1\u05D0\u05E4",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledIconWrapper, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CompaniesWhatsappIcon, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledSubtitle, {
            children: "\u05D5\u05D5\u05D0\u05D8\u05E1\u05D0\u05E4"
          })]
        })
      })]
    })]
  });
};

/* harmony default export */ var Companies_SocialSection = (SocialSection);
;// CONCATENATED MODULE: ./components/Companies/CompaniesPage.tsx








function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



















var RECAPTCHA_KEY = "6LdBc5YiAAAAABjC-OWsg7BFb01Rd-j-nwJcXLx-";

if (!RECAPTCHA_KEY) {
  throw new Error("Please provide the RECAPTCHA_KEY environment variable.");
}

var StyledCenteredContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CompaniesPage__StyledCenteredContent",
  componentId: "sc-1nsfz4u-0"
})(["display:flex;justify-content:center;"]);
var StyledWrapper = (0,styled_components_browser_esm/* default */.ZP)(Container/* default */.Z).withConfig({
  displayName: "CompaniesPage__StyledWrapper",
  componentId: "sc-1nsfz4u-1"
})(["margin-top:79px;padding-right:0px;padding-left:0px;width:100%;", "{display:flex;flex-direction:row-reverse;justify-content:space-between;margin-top:40px;width:1160px;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledImageWrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "CompaniesPage__StyledImageWrapper",
  componentId: "sc-1nsfz4u-2"
})(["position:relative;top:-70px;", "{height:250px;top:0px;}"], function (p) {
  return p.theme.breakpoints.down("sm");
});
var StyledImage = (0,styled_components_browser_esm/* default */.ZP)((image_default())).withConfig({
  displayName: "CompaniesPage__StyledImage",
  componentId: "sc-1nsfz4u-3"
})(["border-radius:8px;"]);
var SvgWrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "CompaniesPage__SvgWrapper",
  componentId: "sc-1nsfz4u-4"
})(["position:absolute;z-index:9;padding-top:16px;padding-right:16px;"]);
var StyledTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  variant: "h1"
}).withConfig({
  displayName: "CompaniesPage__StyledTitle",
  componentId: "sc-1nsfz4u-5"
})(["text-align:right;margin-top:20px;font-size:40px;line-height:46px;", "{margin-top:0px;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var CompaniesPage_StyledSubtitle = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  variant: "body1"
}).withConfig({
  displayName: "CompaniesPage__StyledSubtitle",
  componentId: "sc-1nsfz4u-6"
})(["text-align:right;margin-bottom:37px;word-break:break-word;", "{margin-top:10px;margin-bottom:60px;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledGenericInput = (0,styled_components_browser_esm/* default */.ZP)(GenericInput/* GenericInput */.j).withConfig({
  displayName: "CompaniesPage__StyledGenericInput",
  componentId: "sc-1nsfz4u-7"
})(["padding-bottom:4px;"]);
var StyledButtonWrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "CompaniesPage__StyledButtonWrapper",
  componentId: "sc-1nsfz4u-8"
})(["width:300px;margin-bottom:40px;margin-top:60px;position:relative;border-radius:8px;", "{margin-top:20px;position:fixed;bottom:0;right:0;width:calc(100% - 32px);border-radius:10px;box-shadow:0 -5px 10px 0 hsla(0,0%,0%,0.12);background-color:#fff;padding:12px 16px 10px 16px;margin-top:0px;z-index:999;margin-bottom:0px;}box-sizing:content-box;"], function (p) {
  return p.theme.breakpoints.down("sm");
});
var StyledButton = (0,styled_components_browser_esm/* default */.ZP)(GenericButton/* default */.Z).withConfig({
  displayName: "CompaniesPage__StyledButton",
  componentId: "sc-1nsfz4u-9"
})(["", ""], function (p) {
  return p.isDisabled && "\n    background: var(--Light-Grey, #f7f7f7);\n    color: rgba(45, 45, 45, 0.72);\n    font-size: 24px;\n    :hover {\n    background: var(--Light-Grey, #f7f7f7);\n\n  } ";
});
var StyledMain = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "CompaniesPage__StyledMain",
  componentId: "sc-1nsfz4u-10"
})(["padding-left:16px;padding-right:16px;", "{padding:0;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledFieldWrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "CompaniesPage__StyledFieldWrapper",
  componentId: "sc-1nsfz4u-11"
})(["> *{width:100%;}", "{gap:30px 0;.MuiFormControl-root{margin-left:10px;}display:flex;flex-direction:row;flex-wrap:wrap;> *{width:220px;}}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledLink = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CompaniesPage__StyledLink",
  componentId: "sc-1nsfz4u-12"
})(["display:flex;cursor:pointer;p{margin-right:8px;}", "{margin-top:120px;padding:0 40px;}", "{svg{circle{fill:white;}}}:hover{text-decoration:underline;}"], function (p) {
  return p.theme.breakpoints.up("md");
}, function (p) {
  return p.theme.breakpoints.down("sm");
});
var StyledNotesWrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "CompaniesPage__StyledNotesWrapper",
  componentId: "sc-1nsfz4u-13"
})(["width:100%;.MuiFormControl-root{width:100%;", "{height:auto;}}textarea{font-size:20px;height:100% !important;font-family:Speedee,NarkisBlock,sans-serif;font-weight:500;}.MuiFormHelperText-root{display:none;}"], function (p) {
  return p.theme.breakpoints.down("sm");
});
var StyledOveralError = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  variant: "body1"
}).withConfig({
  displayName: "CompaniesPage__StyledOveralError",
  componentId: "sc-1nsfz4u-14"
})(["font-size:18px;line-height:24px;color:#d70202;text-align:right;", ";", ";", "{margin-top:10px;}"], function (p) {
  return p.$isDesktop && "position: absolute";
}, function (p) {
  return p.$isDesktop && "bottom: 50px";
}, function (p) {
  return p.theme.breakpoints.down("sm");
});
var StyledIconBtn = (0,styled_components_browser_esm/* default */.ZP)(IconButton/* default */.Z).withConfig({
  displayName: "CompaniesPage__StyledIconBtn",
  componentId: "sc-1nsfz4u-15"
})(["padding:0px;"]);
var StyledTextBox = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "CompaniesPage__StyledTextBox",
  componentId: "sc-1nsfz4u-16"
})(["display:flex;flex-direction:row;justify-content:space-between;", "{width:680px;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledTypography = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  variant: "body1"
}).withConfig({
  displayName: "CompaniesPage__StyledTypography",
  componentId: "sc-1nsfz4u-17"
})(["margin-top:7px;"]);
var StyledBackWrapper = (0,styled_components_browser_esm/* default */.ZP)(Container/* default */.Z).withConfig({
  displayName: "CompaniesPage__StyledBackWrapper",
  componentId: "sc-1nsfz4u-18"
})([""]);

var CompaniesPage = function CompaniesPage(_ref) {
  var _companiesData$email;

  var data = _ref.data,
      setCompaniesSteps = _ref.setCompaniesSteps;
  var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();
  var reCaptchaRef = /*#__PURE__*/(0,react.createRef)();

  var _useState = (0,react.useState)(true),
      isValid = _useState[0],
      setIsValid = _useState[1];

  var _useCompaniesContext = (0,CompaniesContext/* useCompaniesContext */.ko)(),
      setCompaniesData = _useCompaniesContext.setCompaniesData,
      companiesData = _useCompaniesContext.companiesData;

  var companiesInitialValues = {
    firstName: (companiesData === null || companiesData === void 0 ? void 0 : companiesData.firstName) || "",
    lastName: (companiesData === null || companiesData === void 0 ? void 0 : companiesData.lastName) || "",
    companyName: (companiesData === null || companiesData === void 0 ? void 0 : companiesData.companyName) || "",
    companyIdNumber: (companiesData === null || companiesData === void 0 ? void 0 : companiesData.companyIdNumber) || "",
    phoneNumber: (companiesData === null || companiesData === void 0 ? void 0 : companiesData.phoneNumber) || "",
    email: (companiesData === null || companiesData === void 0 ? void 0 : (_companiesData$email = companiesData.email) === null || _companiesData$email === void 0 ? void 0 : _companiesData$email.trim()) || "",
    notes: (companiesData === null || companiesData === void 0 ? void 0 : companiesData.notes) || "",
    gRecaptchaResponse: true
  };
  var router = (0,next_router.useRouter)();

  var handlePhoneInput = function handlePhoneInput(evt, formik, fieldName) {
    if (evt.target.value.length) {
      var formattedValue = (0,Functions/* formatPhoneNumber */.un)(evt.target.value);
      setTimeout(function () {
        formik.setFieldValue(fieldName, formattedValue);
      }, 0);
    }
  };

  var formIsValid = function formIsValid(formik) {
    setIsValid(formik.isValid && Object.keys(formik.touched).length > 0);
  };

  var saveCompaniesData = function saveCompaniesData(values) {
    return setCompaniesData(values);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [isDesktop && /*#__PURE__*/(0,jsx_runtime.jsx)(StyledBackWrapper, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledLink, {
        onClick: function onClick() {
          return router.back();
        },
        onKeyDown: function onKeyDown(e) {
          if (e.key === "Enter") router.back();
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledIconBtn, {
          "aria-label": "\u05D7\u05D6\u05E8\u05D4 \u05DC\u05E2\u05DE\u05D5\u05D3 \u05E7\u05D5\u05D3\u05DD",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(BackIcon/* default */.Z, {})
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
          variant: "body1",
          children: "\u05D7\u05D6\u05E8\u05D4"
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledCenteredContent, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledWrapper, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(StyledImageWrapper, {
          children: [!isDesktop && /*#__PURE__*/(0,jsx_runtime.jsx)(SvgWrapper, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(StyledIconBtn, {
              onClick: function onClick() {
                return router.back();
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(BackIcon/* default */.Z, {})
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledImage, {
            src: "/girl-with-chips.jpg",
            layout: !isDesktop ? "fill" : "fixed",
            width: isDesktop && "404x",
            height: isDesktop && "267px",
            alt: "\u05D2\u05D9\u05E4\u05D8\u05E7\u05D0\u05E8\u05D3 \u05DE\u05E7\u05D3\u05D5\u05E0\u05DC\u05D3'\u05E1 \u05DC\u05E2\u05D5\u05D1\u05D3\u05D9\u05DD"
          }), isDesktop && /*#__PURE__*/(0,jsx_runtime.jsx)(Companies_SocialSection, {
            phone: data.customerServiceNumber,
            whatsapp: data.whatsappLink
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledMain, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledTitle, {
            children: "\u05D2\u05D9\u05E4\u05D8\u05E7\u05D0\u05E8\u05D3 \u05DE\u05E7\u05D3\u05D5\u05E0\u05DC\u05D3'\u05E1 \u05DC\u05E2\u05D5\u05D1\u05D3\u05D9\u05DD"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(CompaniesPage_StyledSubtitle, {
            children: data !== null && data !== void 0 && data.body ? data.body : "מזינים את הפרטים ונחזור אליכם בקרוב עם הצעה שווה ומשתלמת לעובדים שלכם!"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormikForm/* default */.Z, {
            validationSchema: CompaniesForm.schemaCompanies,
            initialValues: companiesInitialValues,
            onSubmit: /*#__PURE__*/function () {
              var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(values) {
                var _reCaptchaRef$current, _reCaptchaRef$current2;

                var recaptchaResponse;
                return regenerator_default().wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        reCaptchaRef === null || reCaptchaRef === void 0 ? void 0 : (_reCaptchaRef$current = reCaptchaRef.current) === null || _reCaptchaRef$current === void 0 ? void 0 : _reCaptchaRef$current.reset();
                        _context.next = 3;
                        return reCaptchaRef === null || reCaptchaRef === void 0 ? void 0 : (_reCaptchaRef$current2 = reCaptchaRef.current) === null || _reCaptchaRef$current2 === void 0 ? void 0 : _reCaptchaRef$current2.executeAsync();

                      case 3:
                        recaptchaResponse = _context.sent;
                        _context.prev = 4;
                        saveCompaniesData(values);
                        _context.next = 8;
                        return (0,api.postLeadCreateLead)(_objectSpread(_objectSpread({}, values), {}, {
                          gRecaptchaResponse: recaptchaResponse
                        }));

                      case 8:
                        setCompaniesSteps(3);
                        setCompaniesData(null);
                        _context.next = 15;
                        break;

                      case 12:
                        _context.prev = 12;
                        _context.t0 = _context["catch"](4);
                        setCompaniesSteps(2);

                      case 15:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee, null, [[4, 12]]);
              }));

              return function (_x) {
                return _ref2.apply(this, arguments);
              };
            }(),
            render: function render(formik) {
              var _formik$values, _formik$values$notes, _formik$values2, _formik$values2$notes;

              return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(StyledFieldWrapper, {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledGenericInput, {
                    $width: "220",
                    name: "firstName",
                    label: "\u05E9\u05DD \u05E4\u05E8\u05D8\u05D9 (*\u05D7\u05D5\u05D1\u05D4)",
                    type: "text",
                    maxLength: 30,
                    autoComplete: "given-name",
                    topMargin: "0"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledGenericInput, {
                    $width: "220",
                    name: "lastName",
                    label: "\u05E9\u05DD \u05DE\u05E9\u05E4\u05D7\u05D4 (*\u05D7\u05D5\u05D1\u05D4)",
                    type: "text",
                    maxLength: 30,
                    autoComplete: "given-name",
                    topMargin: "0"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledGenericInput, {
                    $width: "220",
                    name: "phoneNumber",
                    label: "\u05D8\u05DC\u05E4\u05D5\u05DF (*\u05D7\u05D5\u05D1\u05D4)",
                    type: "text",
                    numeric: true,
                    autoComplete: "tel",
                    topMargin: "0",
                    onInput: function onInput(e) {
                      return handlePhoneInput(e, formik, "phoneNumber");
                    },
                    onPaste: /*#__PURE__*/function () {
                      var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(e) {
                        var clipboardData;
                        return regenerator_default().wrap(function _callee3$(_context3) {
                          while (1) {
                            switch (_context3.prev = _context3.next) {
                              case 0:
                                clipboardData = e.clipboardData.getData("Text");
                                e.clipboardData.clearData();
                                setTimeout( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
                                  var phone;
                                  return regenerator_default().wrap(function _callee2$(_context2) {
                                    while (1) {
                                      switch (_context2.prev = _context2.next) {
                                        case 0:
                                          phone = (0,Functions/* formatPhoneNumber */.un)(clipboardData);
                                          formik.setFieldValue("phoneNumber", phone);

                                        case 2:
                                        case "end":
                                          return _context2.stop();
                                      }
                                    }
                                  }, _callee2);
                                })), 300);

                              case 3:
                              case "end":
                                return _context3.stop();
                            }
                          }
                        }, _callee3);
                      }));

                      return function (_x2) {
                        return _ref3.apply(this, arguments);
                      };
                    }()
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledGenericInput, {
                    $width: "220",
                    name: "email",
                    label: "\u05D0\u05D9\u05DE\u05D9\u05D9\u05DC (*\u05D7\u05D5\u05D1\u05D4)",
                    type: "text",
                    autoComplete: "email",
                    inputMode: "email",
                    $unicodeBidi: formik.values.email.match(/[a-zA-Z]/) ? "plaintext" : "normal",
                    topMargin: "0"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledGenericInput, {
                    $width: "220",
                    name: "companyName",
                    label: "\u05E9\u05DD \u05D4\u05D7\u05D1\u05E8\u05D4 (*\u05D7\u05D5\u05D1\u05D4)",
                    type: "text",
                    maxLength: 30,
                    autoComplete: "given-name",
                    topMargin: "0"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledGenericInput, {
                    $width: "220",
                    name: "companyIdNumber",
                    label: "\u05DE\u05E1\u05E4\u05E8 \u05D7.\u05E4. (*\u05D7\u05D5\u05D1\u05D4)",
                    type: "text",
                    maxLength: 9,
                    autoComplete: "given-name",
                    topMargin: "0"
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledNotesWrapper, {
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledGenericInput, {
                      name: "notes",
                      $width: "680",
                      $height: "120",
                      label: "\u05D4\u05E2\u05E8\u05D5\u05EA",
                      type: "text",
                      InputProps: {
                        multiline: true
                      },
                      maxLength: 500,
                      topMargin: "0"
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledTextBox, {
                      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledTypography, {
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
                          component: "span",
                          fontWeight: ((_formik$values = formik.values) === null || _formik$values === void 0 ? void 0 : (_formik$values$notes = _formik$values.notes) === null || _formik$values$notes === void 0 ? void 0 : _formik$values$notes.length) > 0 ? "bold" : "normal",
                          children: ((_formik$values2 = formik.values) === null || _formik$values2 === void 0 ? void 0 : (_formik$values2$notes = _formik$values2.notes) === null || _formik$values2$notes === void 0 ? void 0 : _formik$values2$notes.length) || 0
                        }), "/500"]
                      })
                    })]
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledButtonWrapper, {
                  children: [!isValid && isDesktop && !formik.isValid && /*#__PURE__*/(0,jsx_runtime.jsx)(StyledOveralError, {
                    $isDesktop: isDesktop,
                    children: "\u05D4\u05E9\u05DC\u05D9\u05DE\u05D5 \u05D0\u05EA \u05D4\u05E4\u05E8\u05D8\u05D9\u05DD \u05D4\u05E0\u05DB\u05D5\u05E0\u05D9\u05DD"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledButton, {
                    type: "submit",
                    btnType: "filled",
                    isDisabled: (formik === null || formik === void 0 ? void 0 : formik.isSubmitting) || !formik.isValid || Object.keys(formik.touched).length === 0,
                    onClick: function onClick() {
                      return formIsValid(formik);
                    },
                    children: "\u05E9\u05DC\u05D9\u05D7\u05D4"
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* default */.Z, {
                  ref: reCaptchaRef,
                  sitekey: RECAPTCHA_KEY,
                  size: "invisible",
                  hl: "iw",
                  tabIndex: -1
                }), !isDesktop && /*#__PURE__*/(0,jsx_runtime.jsx)(Companies_SocialSection, {
                  phone: data.customerServiceNumber,
                  whatsapp: data.whatsappLink
                }), !isValid && !isDesktop && !formik.isValid && /*#__PURE__*/(0,jsx_runtime.jsx)(StyledOveralError, {
                  children: "\u05D4\u05E9\u05DC\u05D9\u05DE\u05D5 \u05D0\u05EA \u05D4\u05E4\u05E8\u05D8\u05D9\u05DD \u05D4\u05E0\u05DB\u05D5\u05E0\u05D9\u05DD"
                })]
              });
            }
          })]
        })]
      })
    })]
  });
};

/* harmony default export */ var Companies_CompaniesPage = (CompaniesPage);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./public/animation/glass.json
var glass = __webpack_require__(51037);
;// CONCATENATED MODULE: ./components/Companies/FailurePage.tsx









var Lottie = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(296), __webpack_require__.e(9260)]).then(__webpack_require__.t.bind(__webpack_require__, 69260, 23));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(69260)];
    }
  }
});
var FailurePage_StyledWrapper = (0,styled_components_browser_esm/* default */.ZP)(Container/* default */.Z).withConfig({
  displayName: "FailurePage__StyledWrapper",
  componentId: "sc-174hu3a-0"
})(["height:100vh;"]);
var FailurePage_StyledTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  variant: "h1"
}).withConfig({
  displayName: "FailurePage__StyledTitle",
  componentId: "sc-174hu3a-1"
})(["font-size:50px;margin-top:35px;line-height:0.8;color:#000;"]);
var StyledText = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  variant: "body1"
}).withConfig({
  displayName: "FailurePage__StyledText",
  componentId: "sc-174hu3a-2"
})(["margin-top:10px;line-height:0.92;", "{margin-top:22px;}"], function (p) {
  return p.theme.breakpoints.down("sm");
});
var FailurePage_StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).attrs({
  variant: "contained"
}).withConfig({
  displayName: "FailurePage__StyledButton",
  componentId: "sc-174hu3a-3"
})(["width:158px;height:48px;background-color:#ffb900;color:black;font-size:24px;font-family:\"NarkisBlock\",sans-serif;margin-top:40px;", "{width:100%;}"], function (p) {
  return p.theme.breakpoints.down("sm");
});
var StyledLottie = (0,styled_components_browser_esm/* default */.ZP)(Lottie).withConfig({
  displayName: "FailurePage__StyledLottie",
  componentId: "sc-174hu3a-4"
})(["height:50%;"]);

var FailurePage = function FailurePage(_ref) {
  var setCompaniesSteps = _ref.setCompaniesSteps;
  (0,react.useEffect)(function () {
    window.scrollTo(0, 0);
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(FailurePage_StyledWrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledLottie, {
      animationData: glass,
      loop: false
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(FailurePage_StyledTitle, {
      children: "\u05D0\u05D5\u05E4\u05E1\u05D9, \u05DE\u05E9\u05D4\u05D5 \u05D4\u05E9\u05EA\u05D1\u05E9 \u05D1\u05D3\u05E8\u05DA"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledText, {
      children: "\u05D4\u05E2\u05DE\u05D5\u05D3 \u05E9\u05D7\u05D9\u05E4\u05E9\u05EA \u05DC\u05D0 \u05E7\u05D9\u05D9\u05DD \u05D0\u05D5 \u05E9\u05D9\u05E9 \u05DB\u05E8\u05D2\u05E2 \u05D1\u05E2\u05D9\u05D4 \u05D6\u05DE\u05E0\u05D9\u05EA \u05DC\u05D4\u05D2\u05D9\u05E2 \u05D0\u05DC\u05D9\u05D5"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(FailurePage_StyledButton, {
      onClick: function onClick() {
        return setCompaniesSteps(1);
      },
      children: "\u05D1\u05D5\u05D0\u05D5 \u05E0\u05E0\u05E1\u05D4 \u05E9\u05D5\u05D1"
    })]
  });
};

/* harmony default export */ var Companies_FailurePage = (FailurePage);
// EXTERNAL MODULE: ./public/animation/Purchase successful.json
var Purchase_successful = __webpack_require__(79412);
;// CONCATENATED MODULE: ./components/Companies/SuccessPage.tsx











var SuccessPage_Lottie = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(296), __webpack_require__.e(9260)]).then(__webpack_require__.t.bind(__webpack_require__, 69260, 23));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(69260)];
    }
  }
});
var SuccessPage_StyledWrapper = (0,styled_components_browser_esm/* default */.ZP)(Container/* default */.Z).withConfig({
  displayName: "SuccessPage__StyledWrapper",
  componentId: "sc-f09dnu-0"
})(["height:100vh;display:flex;flex-direction:column;align-items:center;justify-content:center;position:relative;", "{height:80vh;justify-content:flex-start;padding-top:50px;}"], function (p) {
  return p.theme.breakpoints.down("sm");
});
var SuccessPage_StyledTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  variant: "h1"
}).withConfig({
  displayName: "SuccessPage__StyledTitle",
  componentId: "sc-f09dnu-1"
})(["font-size:40px;line-height:0.8;color:#000;margin-top:-35px;", "{margin-top:-80px;font-size:50px;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var SuccessPage_StyledText = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  variant: "body1"
}).withConfig({
  displayName: "SuccessPage__StyledText",
  componentId: "sc-f09dnu-2"
})(["margin-top:10px;line-height:0.92;", "{margin-top:22px;}"], function (p) {
  return p.theme.breakpoints.down("sm");
});
var SuccessPage_StyledButtonWrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "SuccessPage__StyledButtonWrapper",
  componentId: "sc-f09dnu-3"
})(["", "{width:100%;position:absolute;padding-left:16px;padding-right:16px;bottom:30px;}", "{margin-top:40px;}"], function (p) {
  return p.theme.breakpoints.down("sm");
}, function (p) {
  return p.theme.breakpoints.up("md");
});
var SuccessPage_StyledLottie = (0,styled_components_browser_esm/* default */.ZP)(SuccessPage_Lottie).withConfig({
  displayName: "SuccessPage__StyledLottie",
  componentId: "sc-f09dnu-4"
})(["width:600px;height:450px;margin-top:-100px;", "{width:368px;height:310px;margin-top:0px;}"], function (p) {
  return p.theme.breakpoints.down("sm");
});

var SuccessPage = function SuccessPage() {
  var router = (0,next_router.useRouter)();
  (0,react.useEffect)(function () {
    window.scrollTo(0, 0);
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(SuccessPage_StyledWrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SuccessPage_StyledLottie, {
      animationData: Purchase_successful,
      loop: false
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(SuccessPage_StyledTitle, {
      children: "\u05EA\u05D5\u05D3\u05D4! \u05E7\u05D9\u05D1\u05DC\u05E0\u05D5 \u05D0\u05EA \u05D4\u05E4\u05E8\u05D8\u05D9\u05DD"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(SuccessPage_StyledText, {
      children: "\u05D0\u05D7\u05D3 \u05DE\u05D4\u05E0\u05E6\u05D9\u05D2\u05D9\u05DD/\u05D5\u05EA \u05E9\u05DC\u05E0\u05D5 \u05D9\u05D7\u05D6\u05D5\u05E8 \u05D0\u05DC\u05D9\u05DA \u05D1\u05D4\u05E7\u05D3\u05DD \u05E2\u05DD \u05D4\u05E6\u05E2\u05D4 \u05DE\u05E9\u05EA\u05DC\u05DE\u05EA :)"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SuccessPage_StyledButtonWrapper, {
      children: [" ", /*#__PURE__*/(0,jsx_runtime.jsx)(GenericButton/* default */.Z, {
        btnType: "filled",
        onClick: function onClick() {
          return router.push("/");
        },
        children: "\u05DC\u05E2\u05DE\u05D5\u05D3 \u05D4\u05D1\u05D9\u05EA"
      })]
    })]
  });
};

/* harmony default export */ var Companies_SuccessPage = (SuccessPage);
;// CONCATENATED MODULE: ./src/pages/companies.tsx








var __N_SSG = true;
var CompaniesSteps;

(function (CompaniesSteps) {
  CompaniesSteps[CompaniesSteps["COMPANIES"] = 1] = "COMPANIES";
  CompaniesSteps[CompaniesSteps["FAIL"] = 2] = "FAIL";
  CompaniesSteps[CompaniesSteps["SUCCESS"] = 3] = "SUCCESS";
})(CompaniesSteps || (CompaniesSteps = {}));

var Companies = function Companies(_ref) {
  var data = _ref.data,
      seo = _ref.seo;

  var _useState = (0,react.useState)(1),
      companiesSteps = _useState[0],
      setCompaniesSteps = _useState[1];

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SeoMetaData/* default */.ZP, {
      data: seo
    }), companiesSteps === CompaniesSteps.FAIL && /*#__PURE__*/(0,jsx_runtime.jsx)(Companies_FailurePage, {
      setCompaniesSteps: setCompaniesSteps
    }), companiesSteps === CompaniesSteps.COMPANIES && /*#__PURE__*/(0,jsx_runtime.jsx)(Companies_CompaniesPage, {
      data: data,
      setCompaniesSteps: setCompaniesSteps
    }), companiesSteps === CompaniesSteps.SUCCESS && /*#__PURE__*/(0,jsx_runtime.jsx)(Companies_SuccessPage, {})]
  });
};

/* harmony default export */ var companies = (Companies);

/***/ }),

/***/ 53352:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/companies",
      function () {
        return __webpack_require__(71947);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 34853:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm; }
});

// UNUSED EXPORTS: ReCAPTCHA

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./node_modules/react-google-recaptcha/lib/esm/recaptcha.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var ReCAPTCHA =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ReCAPTCHA, _React$Component);

  function ReCAPTCHA() {
    var _this;

    _this = _React$Component.call(this) || this;
    _this.handleExpired = _this.handleExpired.bind(_assertThisInitialized(_this));
    _this.handleErrored = _this.handleErrored.bind(_assertThisInitialized(_this));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleRecaptchaRef = _this.handleRecaptchaRef.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = ReCAPTCHA.prototype;

  _proto.getValue = function getValue() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      return this.props.grecaptcha.getResponse(this._widgetId);
    }

    return null;
  };

  _proto.getWidgetId = function getWidgetId() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      return this._widgetId;
    }

    return null;
  };

  _proto.execute = function execute() {
    var grecaptcha = this.props.grecaptcha;

    if (grecaptcha && this._widgetId !== undefined) {
      return grecaptcha.execute(this._widgetId);
    } else {
      this._executeRequested = true;
    }
  };

  _proto.executeAsync = function executeAsync() {
    var _this2 = this;

    return new Promise(function (resolve, reject) {
      _this2.executionResolve = resolve;
      _this2.executionReject = reject;

      _this2.execute();
    });
  };

  _proto.reset = function reset() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      this.props.grecaptcha.reset(this._widgetId);
    }
  };

  _proto.handleExpired = function handleExpired() {
    if (this.props.onExpired) {
      this.props.onExpired();
    } else {
      this.handleChange(null);
    }
  };

  _proto.handleErrored = function handleErrored() {
    if (this.props.onErrored) {
      this.props.onErrored();
    }

    if (this.executionReject) {
      this.executionReject();
      delete this.executionResolve;
      delete this.executionReject;
    }
  };

  _proto.handleChange = function handleChange(token) {
    if (this.props.onChange) {
      this.props.onChange(token);
    }

    if (this.executionResolve) {
      this.executionResolve(token);
      delete this.executionReject;
      delete this.executionResolve;
    }
  };

  _proto.explicitRender = function explicitRender() {
    if (this.props.grecaptcha && this.props.grecaptcha.render && this._widgetId === undefined) {
      var wrapper = document.createElement("div");
      this._widgetId = this.props.grecaptcha.render(wrapper, {
        sitekey: this.props.sitekey,
        callback: this.handleChange,
        theme: this.props.theme,
        type: this.props.type,
        tabindex: this.props.tabindex,
        "expired-callback": this.handleExpired,
        "error-callback": this.handleErrored,
        size: this.props.size,
        stoken: this.props.stoken,
        hl: this.props.hl,
        badge: this.props.badge
      });
      this.captcha.appendChild(wrapper);
    }

    if (this._executeRequested && this.props.grecaptcha && this._widgetId !== undefined) {
      this._executeRequested = false;
      this.execute();
    }
  };

  _proto.componentDidMount = function componentDidMount() {
    this.explicitRender();
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this.explicitRender();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this._widgetId !== undefined) {
      this.delayOfCaptchaIframeRemoving();
      this.reset();
    }
  };

  _proto.delayOfCaptchaIframeRemoving = function delayOfCaptchaIframeRemoving() {
    var temporaryNode = document.createElement("div");
    document.body.appendChild(temporaryNode);
    temporaryNode.style.display = "none"; // move of the recaptcha to a temporary node

    while (this.captcha.firstChild) {
      temporaryNode.appendChild(this.captcha.firstChild);
    } // delete the temporary node after reset will be done


    setTimeout(function () {
      document.body.removeChild(temporaryNode);
    }, 5000);
  };

  _proto.handleRecaptchaRef = function handleRecaptchaRef(elem) {
    this.captcha = elem;
  };

  _proto.render = function render() {
    // consume properties owned by the reCATPCHA, pass the rest to the div so the user can style it.

    /* eslint-disable no-unused-vars */
    var _this$props = this.props,
        sitekey = _this$props.sitekey,
        onChange = _this$props.onChange,
        theme = _this$props.theme,
        type = _this$props.type,
        tabindex = _this$props.tabindex,
        onExpired = _this$props.onExpired,
        onErrored = _this$props.onErrored,
        size = _this$props.size,
        stoken = _this$props.stoken,
        grecaptcha = _this$props.grecaptcha,
        badge = _this$props.badge,
        hl = _this$props.hl,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["sitekey", "onChange", "theme", "type", "tabindex", "onExpired", "onErrored", "size", "stoken", "grecaptcha", "badge", "hl"]);
    /* eslint-enable no-unused-vars */


    return react.createElement("div", _extends({}, childProps, {
      ref: this.handleRecaptchaRef
    }));
  };

  return ReCAPTCHA;
}(react.Component);


ReCAPTCHA.displayName = "ReCAPTCHA";
ReCAPTCHA.propTypes = {
  sitekey: (prop_types_default()).string.isRequired,
  onChange: (prop_types_default()).func,
  grecaptcha: (prop_types_default()).object,
  theme: prop_types_default().oneOf(["dark", "light"]),
  type: prop_types_default().oneOf(["image", "audio"]),
  tabindex: (prop_types_default()).number,
  onExpired: (prop_types_default()).func,
  onErrored: (prop_types_default()).func,
  size: prop_types_default().oneOf(["compact", "normal", "invisible"]),
  stoken: (prop_types_default()).string,
  hl: (prop_types_default()).string,
  badge: prop_types_default().oneOf(["bottomright", "bottomleft", "inline"])
};
ReCAPTCHA.defaultProps = {
  onChange: function onChange() {},
  theme: "light",
  type: "image",
  tabindex: 0,
  size: "normal",
  badge: "bottomright"
};
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
;// CONCATENATED MODULE: ./node_modules/react-async-script/lib/esm/async-script-loader.js
function async_script_loader_extends() { async_script_loader_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return async_script_loader_extends.apply(this, arguments); }

function async_script_loader_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function async_script_loader_inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var SCRIPT_MAP = {}; // A counter used to generate a unique id for each component that uses the function

var idCount = 0;
function makeAsyncScript(getScriptURL, options) {
  options = options || {};
  return function wrapWithAsyncScript(WrappedComponent) {
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";

    var AsyncScriptLoader =
    /*#__PURE__*/
    function (_Component) {
      async_script_loader_inheritsLoose(AsyncScriptLoader, _Component);

      function AsyncScriptLoader(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.state = {};
        _this.__scriptURL = "";
        return _this;
      }

      var _proto = AsyncScriptLoader.prototype;

      _proto.asyncScriptLoaderGetScriptLoaderID = function asyncScriptLoaderGetScriptLoaderID() {
        if (!this.__scriptLoaderID) {
          this.__scriptLoaderID = "async-script-loader-" + idCount++;
        }

        return this.__scriptLoaderID;
      };

      _proto.setupScriptURL = function setupScriptURL() {
        this.__scriptURL = typeof getScriptURL === "function" ? getScriptURL() : getScriptURL;
        return this.__scriptURL;
      };

      _proto.asyncScriptLoaderHandleLoad = function asyncScriptLoaderHandleLoad(state) {
        var _this2 = this;

        // use reacts setState callback to fire props.asyncScriptOnLoad with new state/entry
        this.setState(state, function () {
          return _this2.props.asyncScriptOnLoad && _this2.props.asyncScriptOnLoad(_this2.state);
        });
      };

      _proto.asyncScriptLoaderTriggerOnScriptLoaded = function asyncScriptLoaderTriggerOnScriptLoaded() {
        var mapEntry = SCRIPT_MAP[this.__scriptURL];

        if (!mapEntry || !mapEntry.loaded) {
          throw new Error("Script is not loaded.");
        }

        for (var obsKey in mapEntry.observers) {
          mapEntry.observers[obsKey](mapEntry);
        }

        delete window[options.callbackName];
      };

      _proto.componentDidMount = function componentDidMount() {
        var _this3 = this;

        var scriptURL = this.setupScriptURL();
        var key = this.asyncScriptLoaderGetScriptLoaderID();
        var _options = options,
            globalName = _options.globalName,
            callbackName = _options.callbackName,
            scriptId = _options.scriptId; // check if global object already attached to window

        if (globalName && typeof window[globalName] !== "undefined") {
          SCRIPT_MAP[scriptURL] = {
            loaded: true,
            observers: {}
          };
        } // check if script loading already


        if (SCRIPT_MAP[scriptURL]) {
          var entry = SCRIPT_MAP[scriptURL]; // if loaded or errored then "finish"

          if (entry && (entry.loaded || entry.errored)) {
            this.asyncScriptLoaderHandleLoad(entry);
            return;
          } // if still loading then callback to observer queue


          entry.observers[key] = function (entry) {
            return _this3.asyncScriptLoaderHandleLoad(entry);
          };

          return;
        }
        /*
         * hasn't started loading
         * start the "magic"
         * setup script to load and observers
         */


        var observers = {};

        observers[key] = function (entry) {
          return _this3.asyncScriptLoaderHandleLoad(entry);
        };

        SCRIPT_MAP[scriptURL] = {
          loaded: false,
          observers: observers
        };
        var script = document.createElement("script");
        script.src = scriptURL;
        script.async = true;

        for (var attribute in options.attributes) {
          script.setAttribute(attribute, options.attributes[attribute]);
        }

        if (scriptId) {
          script.id = scriptId;
        }

        var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(func) {
          if (SCRIPT_MAP[scriptURL]) {
            var mapEntry = SCRIPT_MAP[scriptURL];
            var observersMap = mapEntry.observers;

            for (var obsKey in observersMap) {
              if (func(observersMap[obsKey])) {
                delete observersMap[obsKey];
              }
            }
          }
        };

        if (callbackName && typeof window !== "undefined") {
          window[callbackName] = function () {
            return _this3.asyncScriptLoaderTriggerOnScriptLoaded();
          };
        }

        script.onload = function () {
          var mapEntry = SCRIPT_MAP[scriptURL];

          if (mapEntry) {
            mapEntry.loaded = true;
            callObserverFuncAndRemoveObserver(function (observer) {
              if (callbackName) {
                return false;
              }

              observer(mapEntry);
              return true;
            });
          }
        };

        script.onerror = function () {
          var mapEntry = SCRIPT_MAP[scriptURL];

          if (mapEntry) {
            mapEntry.errored = true;
            callObserverFuncAndRemoveObserver(function (observer) {
              observer(mapEntry);
              return true;
            });
          }
        };

        document.body.appendChild(script);
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        // Remove tag script
        var scriptURL = this.__scriptURL;

        if (options.removeOnUnmount === true) {
          var allScripts = document.getElementsByTagName("script");

          for (var i = 0; i < allScripts.length; i += 1) {
            if (allScripts[i].src.indexOf(scriptURL) > -1) {
              if (allScripts[i].parentNode) {
                allScripts[i].parentNode.removeChild(allScripts[i]);
              }
            }
          }
        } // Clean the observer entry


        var mapEntry = SCRIPT_MAP[scriptURL];

        if (mapEntry) {
          delete mapEntry.observers[this.asyncScriptLoaderGetScriptLoaderID()];

          if (options.removeOnUnmount === true) {
            delete SCRIPT_MAP[scriptURL];
          }
        }
      };

      _proto.render = function render() {
        var globalName = options.globalName; // remove asyncScriptOnLoad from childProps

        var _this$props = this.props,
            asyncScriptOnLoad = _this$props.asyncScriptOnLoad,
            forwardedRef = _this$props.forwardedRef,
            childProps = async_script_loader_objectWithoutPropertiesLoose(_this$props, ["asyncScriptOnLoad", "forwardedRef"]); // eslint-disable-line no-unused-vars


        if (globalName && typeof window !== "undefined") {
          childProps[globalName] = typeof window[globalName] !== "undefined" ? window[globalName] : undefined;
        }

        childProps.ref = forwardedRef;
        return (0,react.createElement)(WrappedComponent, childProps);
      };

      return AsyncScriptLoader;
    }(react.Component); // Note the second param "ref" provided by React.forwardRef.
    // We can pass it along to AsyncScriptLoader as a regular prop, e.g. "forwardedRef"
    // And it can then be attached to the Component.


    var ForwardedComponent = (0,react.forwardRef)(function (props, ref) {
      return (0,react.createElement)(AsyncScriptLoader, async_script_loader_extends({}, props, {
        forwardedRef: ref
      }));
    });
    ForwardedComponent.displayName = "AsyncScriptLoader(" + wrappedComponentName + ")";
    ForwardedComponent.propTypes = {
      asyncScriptOnLoad: (prop_types_default()).func
    };
    return hoist_non_react_statics_cjs_default()(ForwardedComponent, WrappedComponent);
  };
}
;// CONCATENATED MODULE: ./node_modules/react-google-recaptcha/lib/esm/recaptcha-wrapper.js


var callbackName = "onloadcallback";
var globalName = "grecaptcha";

function getOptions() {
  return typeof window !== "undefined" && window.recaptchaOptions || {};
}

function getURL() {
  var dynamicOptions = getOptions();
  var hostname = dynamicOptions.useRecaptchaNet ? "recaptcha.net" : "www.google.com";
  return "https://" + hostname + "/recaptcha/api.js?onload=" + callbackName + "&render=explicit";
}

/* harmony default export */ var recaptcha_wrapper = (makeAsyncScript(getURL, {
  callbackName: callbackName,
  globalName: globalName
})(ReCAPTCHA));
;// CONCATENATED MODULE: ./node_modules/react-google-recaptcha/lib/esm/index.js


/* harmony default export */ var esm = (recaptcha_wrapper);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2726,3450,2198,3818,7072,4055,9904,9774,2888,179], function() { return __webpack_exec__(53352); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);